import { configureStore } from '@reduxjs/toolkit'
import rootReducer from 'presentation/redux/reducers'

export default configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.error.content'],
        // Ignore these paths in the state
        ignoredPaths: ['student.errorsExcel.error.content'],
      },
    }),
  reducer: rootReducer,
})
